const DEBUG = true;
const BH_APP_API_URL = "https://bh-app-api.bombayhair.ca/api/v1";
const WISHLIST_END_POINT = "/wishlist";
const WISHLIST_API_URL = `${BH_APP_API_URL}${WISHLIST_END_POINT}`;
const GET_WISHLIST_DATA_URL = `${WISHLIST_API_URL}/get-data`;
const TOGGLE_WISHLIST_DATA_URL = `${WISHLIST_API_URL}/toggle`;
const WISHLIST_STATUS_URL = `${WISHLIST_API_URL}/status`;
const BH_APP_KEY = "bh_app_8e98yuweuiwer7uirtew";
let CUSTOMER_ID = null;

const showToast = (message) => {
  Toastify({
    text: message,
    duration: 3000,
    close: true,
    gravity: "bottom",
    position: "right",
    style: {
      background: "#cd0c63",
    },
    stopOnFocus: true,
    escapeMarkup: false
  }).showToast();
}

const printBrowserConsole = (message, style = "color: #008b00ff; font-weight: bold", ...args) => {
  if (DEBUG) {
    if (typeof message === "string") {
      console.log(`%c${message}`, style, ...args);
    } else {
      // If the first argument isn't a string, style doesn't apply
      console.log(message, ...[...args]);
    }
  }
};

// Redirecting to wishlist page
const redirectToWishlistPage = () => {
  const wishlistHeaderButton = document.getElementById("wishlist");
  wishlistHeaderButton.addEventListener("click", () => {
    window.location.href = '/pages/favorites';
  });
}

const init = () => {
  printBrowserConsole("Intializing wishlist script...");

  // Redirecting to wishlist page
  redirectToWishlistPage();

  printBrowserConsole("Wishlist script initialized");
}

const initIfUserLoggedIn = async () => {
  if (window.cffCustomer) {
    CUSTOMER_ID = window.cffCustomer.id;
    printBrowserConsole(`User is logged in with ID: ${CUSTOMER_ID}`);

    const wishlistedData = await getWishlistData(GET_WISHLIST_DATA_URL, CUSTOMER_ID);
    const wishlistedProductCount = wishlistedData.length;
    initWishlistsCount(wishlistedProductCount);

  }
}

const removeIndividualWishlistItem = () => {
  // Attach click event to all remove buttons
  document.querySelectorAll(".remove-wishlist-item").forEach((button) => {
    button.addEventListener("click", async () => {
      button.disabled = true;
      button.textContent = "Removing...";

      // Get the parent <tr> element
      const row = button.closest(".wishlist-item");
      const wishlistPage = document.querySelector(".wishlist-page");

      await toggleWishlist(TOGGLE_WISHLIST_DATA_URL, CUSTOMER_ID, button).then(async () => {   
          printBrowserConsole("Product removed from wishlist successfully");     
          row.remove();
          // Check if any wishlist items remain
          const remainingItems = document.querySelectorAll(".wishlist-item");
          if (remainingItems.length === 0) {
            wishlistPage.innerHTML = '<div class="ib-wishlist-no-items">No Items Available!</div>';
          }
      }).catch((error) => {
        printBrowserConsole(`Error removing product from wishlist:`, error);
      });      
    });
  });
}

const addIndividualWishlistItemToCart = () => {
  // Attach click event to all add to cart buttons
  document.querySelectorAll(".move-wishlist-to-cart").forEach((button) => {
    button.addEventListener("click", async () => {
      button.disabled = true;
      button.textContent = "Adding...";

      const variantId = button.getAttribute("data-variant-id");
      const productTitle = button.getAttribute("data-product-title");

      // Get the parent <tr> element
      const row = button.closest(".wishlist-item");
      
      const wishlistPage = document.querySelector(".wishlist-page");

      await addToCart(variantId).then(async () => {
        printBrowserConsole(`Product ${productTitle} added to cart successfully`);
        await toggleWishlist(TOGGLE_WISHLIST_DATA_URL, CUSTOMER_ID, button).then(() => {
          printBrowserConsole(`Product ${productTitle} removed from wishlist successfully`);
          row.remove();
          showToast(`<strong>${productTitle}</strong> has been added to your cart.`);
          // Check if any wishlist items remain
          const remainingItems = document.querySelectorAll(".wishlist-item");
          if (remainingItems.length === 0) {
            wishlistPage.innerHTML = '<div class="ib-wishlist-no-items">No Items Available!</div>';
          }
        });
      }).catch((error) => {
        printBrowserConsole(`Error adding product ${productTitle} to cart:`, error);
      });
    });
  });
};

const addProductToWishlist = () => {
  // Get all the div elements for adding/removing favorites
  const favoriteItems = document.querySelectorAll(".ib-favorite-heart");
  // Loop through each item
  favoriteItems.forEach(async (item) => {
    const productId = item.getAttribute("data-product-id");

    const isWishlisted = await checkWishlistStatus(WISHLIST_STATUS_URL, CUSTOMER_ID, productId);
    console.log(isWishlisted);
    const heartIcon = item.querySelector("i");
    if (isWishlisted) {
      heartIcon.classList.remove("fa-heart-o");
      heartIcon.classList.remove("fa-spinner");
      heartIcon.classList.remove("fa-spin");
      heartIcon.classList.add("fa-heart");
    } else {
      heartIcon.classList.remove("fa-heart");
      heartIcon.classList.remove("fa-spinner");
      heartIcon.classList.remove("fa-spin");
      heartIcon.classList.add("fa-heart-o");
    }
    if (!item.dataset.listenerAttached) {
      item.addEventListener("click", async function () {

        // heartIcon.classList.add("fa-spinner", "fa-spin");
        // await toggleWishlist(TOGGLE_WISHLIST_DATA_URL, CUSTOMER_ID, item);
        // heartIcon.classList.remove("fa-spinner", "fa-spin");
          const heartIcon = item.querySelector("i");
          heartIcon.classList.add("fa-spinner");
          heartIcon.classList.add("fa-spin");
          await toggleWishlist(TOGGLE_WISHLIST_DATA_URL, CUSTOMER_ID, item);
          heartIcon.classList.remove("fa-spinner");
          heartIcon.classList.remove("fa-spin");
      });
      item.dataset.listenerAttached = "true";
    }
    // item.addEventListener("click", async function () {
    //   const heartIcon = item.querySelector("i");
    //   heartIcon.classList.add("fa-spinner");
    //   heartIcon.classList.add("fa-spin");
    //   await toggleWishlist(TOGGLE_WISHLIST_DATA_URL, CUSTOMER_ID, item);
    //   heartIcon.classList.remove("fa-spinner");
    //   heartIcon.classList.remove("fa-spin");
    // });
  });
}

const addAllWishlistItemsToCart = () => {
  const moveAllButton = document.getElementById("move-all-to-cart");

  if (!moveAllButton) {
    printBrowserConsole("Move All to Cart button not found");
    return;
  }

  moveAllButton.addEventListener("click", async () => {
    moveAllButton.disabled = true;
    moveAllButton.textContent = "Moving...";

    showWishlistOverlayLoader();

    const buttons = document.querySelectorAll(".move-wishlist-to-cart");
    const wishlistPage = document.querySelector(".wishlist-page");

    for (const button of buttons) {
      const variantId = button.getAttribute("data-variant-id");
      const row = button.closest(".wishlist-item");

      try {
        await addToCart(variantId);
        await toggleWishlist(TOGGLE_WISHLIST_DATA_URL, CUSTOMER_ID, button);
        row.remove();
      } catch (error) {
        printBrowserConsole("Error processing item:", error);
        button.textContent = "Failed";
        button.disabled = false;
      }
    }

    // Remove loader
    removeWishlistOverlayLoader();

    // Check if any wishlist items remain
    const remainingItems = document.querySelectorAll(".wishlist-item");
    if (remainingItems.length === 0) {
      wishlistPage.innerHTML = '<div class="ib-wishlist-no-items">No Items Available!</div>';
    }

    moveAllButton.disabled = false;
    moveAllButton.textContent = "Move All to Cart";
  });
}

// Create and show overlay loader
const showWishlistOverlayLoader = () => {
  const overlay = document.createElement("div");
  overlay.id = "wishlist-overlay-loader";
  overlay.innerHTML = `
    <div class="wishlist-loader-content">
      <div class="spinner"></div>
      <p>Adding items to cart...</p>
    </div>
  `;
  document.body.appendChild(overlay);
};

// Remove overlay loader
const removeWishlistOverlayLoader = () => {
  const overlay = document.getElementById("wishlist-overlay-loader");
  if (overlay) overlay.remove();
};

document.addEventListener("DOMContentLoaded", async function () {
  
  init();
  printBrowserConsole("DOMContentLoaded event fired, wishlist script is ready");
  if (window.cffCustomer) {

    await initIfUserLoggedIn();
    
    addProductToWishlist();

    removeIndividualWishlistItem();

    addIndividualWishlistItemToCart();

    addAllWishlistItemsToCart();

    observeDOMChanges();

  } else {
    const favoriteItems = document.querySelectorAll(".ib-favorite-heart");
    favoriteItems.forEach((item) => {
      item.addEventListener("click", function () {
        document.querySelector(".ib-login-alert.popup").style.display = "flex";
        //alert("Please login to add to favorites!");
      });
    });
  }
});

// Function to handle add/remove from favorites
const toggleWishlist = async (url, customer_id, item) => {
  const productId = item.getAttribute("data-product-id");
  const variantId = item.getAttribute("data-variant-id");
  const productTitle = item.getAttribute("data-product-title");
  const productPrice = item.getAttribute("data-product-price");
  const productImage = item.getAttribute("data-product-image");
  const productUrl = item.getAttribute("data-product-url");

  const product = {
    id: productId,
    variantId: variantId,
    title: productTitle,
    price: productPrice,
    image: productImage,
    url: productUrl,
  };

  const toggled = await fetch(url, {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      "Authorization": BH_APP_KEY
    },
    body: JSON.stringify({
      customer_id: customer_id,
      product: product
    })
  });

  const result = await toggled.json();
  if (result.success) {
    const heartIcon = item.querySelector("i");
    if (result.added) {
      console.log(result);
      console.log(heartIcon);
      updateFavoritesCount("added");
      if (heartIcon) {
        heartIcon.classList.remove("fa-heart-o");
        heartIcon.classList.add("fa-heart");
      }
    } else {
      updateFavoritesCount("removed");
      if (heartIcon) {
        heartIcon.classList.remove("fa-heart");
        heartIcon.classList.add("fa-heart-o");
      }
    }
    showToast(`<strong>${productTitle} </strong>${result.message}`);
  }
}

const getWishlistData = async (url, customer_id) => {
  const response = await fetch(`${url}?customerId=${customer_id}`, {
    method: "GET",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      "Authorization": BH_APP_KEY
    }
  });

  const result = await response.json();
  if (result.success) {
    return result.data;
  } else {
    printBrowserConsole("Error fetching wishlist data:", result.message);
    return [];
  }
}

const initWishlistsCount = (count) => {
  document.querySelector('.wishlist-count-bubble').innerHTML = count;
}

// Function to update the favorites count
const updateFavoritesCount = (status) => {
  const wishlistCountElement = document.querySelector(".wishlist-count-bubble");
  const currentWishlistCount = parseInt(wishlistCountElement.innerHTML);
  let updatedCount = 0;
  if (status == 'added') updatedCount = currentWishlistCount + 1;
  else updatedCount = currentWishlistCount - 1;
  wishlistCountElement.innerHTML = updatedCount;
}

// Function to check status of wishlist by ProductId
const checkWishlistStatus = async (url, customer_id, product_id) => {
  const response = await fetch(`${url}/${customer_id}/${product_id}`, {
    method: "GET",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      "Authorization": BH_APP_KEY
    }
  });

  const result = await response.json();
  if (result.success) {
    return result.data.isWishlisted;
  }
}

// Function to add individual item to cart
const addToCart = async (variantId, quantity = 1) => {
  return await fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ id: variantId, quantity })
  }).then(async (res) => {
    if (!res.ok) throw new Error('Add to cart failed');
    const json = await res.json();
    window.SLIDECART_UPDATE();
    return json;
  });
}

// This below code ensures that even after user changes product by clicking on new color swatch the wishlist shows popup when clicked and user is not logged in.
document.body.addEventListener("click", function(e) {
    const heart = e.target.closest(".ib-favorite-heart");
    if (heart && !window.cffCustomer) {
        document.querySelector(".ib-login-alert.popup").style.display = "flex";
        e.preventDefault();
        return false;
    }
});

function observeDOMChanges(targetNode = document.body, delay = 300) {
  const config = { childList: true, subtree: true };
  let timeoutId = null;
  const callback = function (mutationsList, observer) {
    if (timeoutId) clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      addProductToWishlist();
    }, delay);
  };
  const observer = new MutationObserver(callback);
  observer.observe(targetNode, config);
  return observer;
}
